export default "__VITE_ASSET__pAr1T$ky__"